

export enum passed_the_military_data {
  EXEMPT = "ได้รับการยกเว้น", // i18n-ignore
  MILITARY_SUBJECT = "ศึกษาวิชาทหาร", // i18n-ignore
  PASSING_MILITARY = "ผ่านการเกณฑ์ทหาร", // i18n-ignore
}

export enum personal_status_data {
  SINGLE = "โสด", // i18n-ignore
  MARRIED = "แต่งงาน", // i18n-ignore
  WIDOWED = "หม้าย", // i18n-ignore
  DIVORCED = "หย่า", // i18n-ignore
  SEPARATED = "แยกกัน", // i18n-ignore
}
export enum driving_skill_enum {
  HAS_DRIVING_SKILLS = "มีความสามารถในการขับขี่", // i18n-ignore
  HAS_DRIVER_LICENSE = "มีใบขับขี่", // i18n-ignore
  PRIVATE_VEHICLE = "มีรถส่วนตัว", // i18n-ignore
}

export enum accept_enum {
  YES = "ได้", // i18n-ignore
  NO = "ไม่ได้", // i18n-ignore
}
export enum accept_enum_two {
  EVER = "เคย", // i18n-ignore
  NEVER = "ไม่เคย", // i18n-ignore
}
export enum accept_enum_three {
  NOT_HAVE = "ไม่มี", // i18n-ignore
  HAVE = "มี", // i18n-ignore
}
export enum category_address_enum {
  PRIVATE_HOME = "บ้านส่วนตัว", // i18n-ignore
  RENTAL_HOME = "บ้านเช่า", // i18n-ignore
  DORMITORY = "หอพัก", // i18n-ignore
  RELATIVE = "ญาติ", // i18n-ignore
  TEMPLE_OR_FAMILY = "วัดหรืออยู่กับครอบครัว", // i18n-ignore
}
export enum Rating {
  BEST = "ดีมาก", // i18n-ignore
  GOOD = "ดี", // i18n-ignore
  FAIR = "พอใช้", // i18n-ignore
  BAD = "แย่", // i18n-ignore
}
export enum FamilyRelationship {
  FATHER = "พ่อ", // i18n-ignore
  MOTHER = "แม่", // i18n-ignore
  SIBLING = "พี่น้อง", // i18n-ignore
  RELATIVE = "ญาติ", // i18n-ignore
  WIFE = "ภรรยา", // i18n-ignore
  CHILD = "ลูก", // i18n-ignore
  OTHER = "อื่นๆ", // i18n-ignore
}
export enum date_time_enum {
  DAY = "วัน", // i18n-ignore
  MONTH = "เดือน", // i18n-ignore
  YEAR = "ปี", // i18n-ignore
}
export enum status_alive_enum {
  ALIVE = "alive",
  DIE = "die",
  DIVORCE = "หย่าร้าง", // i18n-ignore
  STAY_TOGETHER = "อยู่ด้วยกัน", // i18n-ignore
}
export enum status_employee {
  ACTIVE = "active",
  DRAFT = "draft",
  END_OF_EMPLOYMENT = "inactive",
}
export enum gender_enum {
  MAN = "ชาย", // i18n-ignore
  GIRL = "หญิง", // i18n-ignore
}
export enum gender_enum_en {
  MAN = "Male",
  GIRL = "Female"
}

export enum religion_enum {
  BUDDHISM = "พุทธ", // i18n-ignore
  CHRISTIANITY = "คริสต์", // i18n-ignore
  ISLAM = "อิสลาม", // i18n-ignore
  HINDUISM = "ฮินดู", // i18n-ignore
  SIKHISM = "ซิกข์", // i18n-ignore
  JUDAISM = "ยูดาย", // i18n-ignore
  SHINTO = "ชินโต", // i18n-ignore
  TAOISM = "เต๋า", // i18n-ignore
  ZOROASTRIANISM = "โซโรอัสเตอร์", // i18n-ignore
  BAHAI = "บาไฮ", // i18n-ignore
  JAINISM = "เชน", // i18n-ignore
  CONFUCIANISM = "ขงจื๊อ", // i18n-ignore
  ANIMISM = "วิญญาณนิยม", // i18n-ignore
  ATHEISM = "อเทวนิยม", // i18n-ignore
  AGNOSTICISM = "อัญญวิศาสตร์", // i18n-ignore
}

export const passed_the_military_data_array: {
  label: string;
  value: passed_the_military_data;
}[] = [
    {
      label: "PERSONAL_MANAGEMENT.DATA.EXEMPT",
      value: passed_the_military_data.EXEMPT,
    },
    {
      label: "PERSONAL_MANAGEMENT.DATA.MILITARY_TRAINING",
      value: passed_the_military_data.MILITARY_SUBJECT,
    },
    {
      label: "PERSONAL_MANAGEMENT.DATA.COMPLETED_SERVICE",
      value: passed_the_military_data.PASSING_MILITARY,
    },
  ];

export const personal_status_data_array: {
  label: string;
  value: personal_status_data;
}[] = [
    {
      label: "PERSONAL_MANAGEMENT.DATA.SINGLE",
      value: personal_status_data.SINGLE,
    },
    {
      label: "PERSONAL_MANAGEMENT.DATA.MARRIED",
      value: personal_status_data.MARRIED,
    },
    {
      label: "PERSONAL_MANAGEMENT.DATA.WIDOWED",
      value: personal_status_data.WIDOWED,
    },
    {
      label: "PERSONAL_MANAGEMENT.DATA.DIVORCED",
      value: personal_status_data.DIVORCED,
    },
    {
      label: "PERSONAL_MANAGEMENT.DATA.SEPARATED",
      value: personal_status_data.SEPARATED,
    },
  ];

export const driving_skill_data: {
  label: string;
  value: driving_skill_enum;
}[] = [
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.HAS_DRIVING_SKILLS",
      value: driving_skill_enum.HAS_DRIVING_SKILLS,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.HAS_DRIVER_LICENSE",
      value: driving_skill_enum.HAS_DRIVER_LICENSE,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.PRIVATE_VEHICLE",
      value: driving_skill_enum.PRIVATE_VEHICLE,
    },
  ];

export const accept_data: { label: string; value: accept_enum }[] = [
  {
    label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.YES",
    value: accept_enum.YES,
  },
  {
    label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.NO",
    value: accept_enum.NO,
  },
];
export const accept_data_two: { label: string; value: accept_enum_two }[] = [
  {
    label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.NEVER",
    value: accept_enum_two.NEVER,
  },
  {
    label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.EVER",
    value: accept_enum_two.EVER,
  },
];
export const accept_data_three: { label: string; value: accept_enum_three }[] =
  [
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.NOT_HAVE",
      value: accept_enum_three.NOT_HAVE,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.HAVE",
      value: accept_enum_three.HAVE,
    },
  ];

export const category_address_data: {
  label: string;
  value: category_address_enum;
}[] = [
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO.PRIVATE_HOME",
      value: category_address_enum.PRIVATE_HOME,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO.RENTAL_HOME",
      value: category_address_enum.RENTAL_HOME,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO.PRIVATE_HOME",
      value: category_address_enum.DORMITORY,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO.RELATIVE",
      value: category_address_enum.RELATIVE,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_TWO.TEMPLE_OR_FAMILY",
      value: category_address_enum.TEMPLE_OR_FAMILY,
    },
  ];

export const level_language_proficiency_data: {
  label: string;
  value: Rating;
}[] = [
    {
      label: `PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.BEST`,
      value: Rating.BEST,
    },
    {
      label: `PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.GOOD`,
      value: Rating.GOOD,
    },
    {
      label: `PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.FAIR`,
      value: Rating.FAIR,
    },
    {
      label: `PERSONAL_MANAGEMENT.DETAIL.STEP_TWO_HALF.BAD`,
      value: Rating.BAD,
    },
  ];

export const family_relationship_data: {
  label: string;
  value: FamilyRelationship;
}[] = [
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.FATHER",
      value: FamilyRelationship.FATHER,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.MOTHER",
      value: FamilyRelationship.MOTHER,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.SIBLING",
      value: FamilyRelationship.SIBLING,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.RELATIVE",
      value: FamilyRelationship.RELATIVE,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.WIFE",
      value: FamilyRelationship.WIFE,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.CHILD",
      value: FamilyRelationship.CHILD,
    },
    {
      label: "PERSONAL_MANAGEMENT.DETAIL.STEP_ONE.OTHER",
      value: FamilyRelationship.OTHER,
    },
  ];

export const date_time_data: { label: string; value: string }[] = [
  {
    label: "PERSONAL_MANAGEMENT.DATA.DAY",
    value: date_time_enum.DAY,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.MONTH",
    value: date_time_enum.MONTH,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.YEAR",
    value: date_time_enum.YEAR,
  },
];

export const status_alive_data: { label: string; value: status_alive_enum }[] =
  [
    {
      label: status_alive_enum.ALIVE,
      value: status_alive_enum.ALIVE,
    },
    {
      label: status_alive_enum.DIE,
      value: status_alive_enum.DIE,
    },
    {
      label: status_alive_enum.DIVORCE,
      value: status_alive_enum.DIVORCE,
    },
    {
      label: status_alive_enum.STAY_TOGETHER,
      value: status_alive_enum.STAY_TOGETHER,
    },
  ];

export const status_employee_data: { label: string; value: string }[] = [
  {
    label: "PERSONAL_MANAGEMENT.STATUS.DRAFT",
    value: "บันทึกร่าง", // i18n-ignore
  },
  {
    label: "PERSONAL_MANAGEMENT.STATUS.STAFF",
    value: status_employee.ACTIVE,
  },
  {
    label: "PERSONAL_MANAGEMENT.STATUS.END_OF_EMPLOYMENT",
    value: status_employee.END_OF_EMPLOYMENT,
  },
];

export const gender_data: { label: string; value: gender_enum }[] = [
  {
    label: "PERSONAL_MANAGEMENT.DATA.MAN",
    value: gender_enum.MAN,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.GIRL",
    value: gender_enum.GIRL,
  },
];

export enum sect_enum {
  // Buddhism
  THERAVADA = "Theravada",
  MAHAYANA = "Mahayana",
  VAJRAYANA = "Vajrayana",

  // Christianity
  ROMAN_CATHOLIC = "Roman Catholic",
  PROTESTANT = "Protestant",
  ORTHODOX = "Orthodox",

  // Islam
  SUNNI = "Sunni",
  SHIA = "Shia",

  // Hinduism
  SHAIVISM = "Shaivism",
  VAISHNAVISM = "Vaishnavism",
  SHAKTISM = "Shaktism",

  // Sikhism
  NIRANKARI = "Nirankari",
  NAMDHARI = "Namdhari",

  // Judaism
  // ORTHODOX = "Orthodox",
  CONSERVATIVE = "Conservative",
  REFORM = "Reform",

  // Jainism
  DIGAMBARA = "Digambara",
  SVETAMBARA = "Svetambara",
}

type sect_type = {
  label: string;
  value: sect_enum;
};
type data_region_type = {
  label: string;
  value: religion_enum;
  sectData?: sect_type[];
};

export const religion_data: data_region_type[] = [
  {
    label: "PERSONAL_MANAGEMENT.DATA.BUDDHISM",
    value: religion_enum.BUDDHISM,
    sectData: [
      {
        label: "PERSONAL_MANAGEMENT.DATA.THERAVADA",
        value: sect_enum.THERAVADA,
      },
      { label: "PERSONAL_MANAGEMENT.DATA.MAHAYANA", value: sect_enum.MAHAYANA },
      {
        label: "PERSONAL_MANAGEMENT.DATA.VAJRAYANA",
        value: sect_enum.VAJRAYANA,
      },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.CHRISTIANITY",
    value: religion_enum.CHRISTIANITY,
    sectData: [
      {
        label: "PERSONAL_MANAGEMENT.DATA.ROMAN_CATHOLIC",
        value: sect_enum.ROMAN_CATHOLIC,
      },
      {
        label: "PERSONAL_MANAGEMENT.DATA.PROTESTANT",
        value: sect_enum.PROTESTANT,
      },
      { label: "PERSONAL_MANAGEMENT.DATA.ORTHODOX", value: sect_enum.ORTHODOX },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.ISLAM",
    value: religion_enum.ISLAM,
    sectData: [
      { label: "PERSONAL_MANAGEMENT.DATA.SUNNI", value: sect_enum.SUNNI },
      { label: "PERSONAL_MANAGEMENT.DATA.SHIA", value: sect_enum.SHIA },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.HINDUISM",
    value: religion_enum.HINDUISM,
    sectData: [
      { label: "PERSONAL_MANAGEMENT.DATA.SHAIVISM", value: sect_enum.SHAIVISM },
      {
        label: "PERSONAL_MANAGEMENT.DATA.VAISHNAVISM",
        value: sect_enum.VAISHNAVISM,
      },
      { label: "PERSONAL_MANAGEMENT.DATA.SHAKTISM", value: sect_enum.SHAKTISM },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.SIKHISM",
    value: religion_enum.SIKHISM,
    sectData: [
      {
        label: "PERSONAL_MANAGEMENT.DATA.NIRANKARI",
        value: sect_enum.NIRANKARI,
      },
      { label: "PERSONAL_MANAGEMENT.DATA.NAMDHARI", value: sect_enum.NAMDHARI },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.JUDAISM",
    value: religion_enum.JUDAISM,
    sectData: [
      { label: "PERSONAL_MANAGEMENT.DATA.ORTHODOX", value: sect_enum.ORTHODOX },
      {
        label: "PERSONAL_MANAGEMENT.DATA.CONSERVATIVE",
        value: sect_enum.CONSERVATIVE,
      },
      { label: "PERSONAL_MANAGEMENT.DATA.REFORM", value: sect_enum.REFORM },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.SHINTO",
    value: religion_enum.SHINTO,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.TAOISM",
    value: religion_enum.TAOISM,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.ZOROASTRIANISM",
    value: religion_enum.ZOROASTRIANISM,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.BAHAI",
    value: religion_enum.BAHAI,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.JAINISM",
    value: religion_enum.JAINISM,
    sectData: [
      {
        label: "PERSONAL_MANAGEMENT.DATA.DIGAMBARA",
        value: sect_enum.DIGAMBARA,
      },
      {
        label: "PERSONAL_MANAGEMENT.DATA.SVETAMBARA",
        value: sect_enum.SVETAMBARA,
      },
    ],
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.CONFUCIANISM",
    value: religion_enum.CONFUCIANISM,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.ANIMISM",
    value: religion_enum.ANIMISM,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.ATHEISM",
    value: religion_enum.ATHEISM,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.AGNOSTICISM",
    value: religion_enum.AGNOSTICISM,
  },
];

export const alive_data: { label: string; value: string }[] = [
  {
    label: "PERSONAL_MANAGEMENT.DATA.ALIVE",
    value: status_alive_enum.ALIVE,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.DECEASED",
    value: status_alive_enum.DIE,
  },
];

export const living_data: { label: string; value: string }[] = [
  {
    label: "PERSONAL_MANAGEMENT.DATA.LIVING_TOGETHER",
    value: status_alive_enum.STAY_TOGETHER,
  },
  {
    label: "PERSONAL_MANAGEMENT.DATA.DIVORCED",
    value: status_alive_enum.DIVORCE,
  },
];



export enum ARTICLE_TYPE {
  RESEARCH = "RESEARCH",
  TREATISE = "TREATISE"
}


export enum BACKGROUND_FILE {
  COVER_IMAGE = 'COVER_IMAGE',
  CV = 'CV',
}

